module.exports = __webpack_public_path__ + "static/media/20.a9d984d5.svg";